import React from 'react';
import ReactDOM from 'react-dom';
import SelectComponent from "./SelectComponent";

const $ = jQuery;

export function createSelect(select: HTMLSelectElement): void {
    const container = document.createElement('div');
    container.classList.add('lf-select');
    select.parentElement!.insertBefore(container, select.nextSibling);

    select.classList.add('reactified');
    select.style.display = 'none';

    select.addEventListener('change', () => {
        console.log('Select value changed', select.value);
    });

    ReactDOM.render(
        React.createElement(SelectComponent, { select, container }, []),
        container,
    );
}

window.Drupal.behaviors.lfSelect = {
    attach: function (context, settings) {
        $('select:not(.reactified)', context).once('reactify-select').each(function(this: HTMLSelectElement) {
            createSelect(this);
        });
    },
}
